export const productsArray = [
    {
      title: "A Simple Yet Special Hamburger",
      description: "Indulge in burger perfection with our Classic Simple Hamburger. Grilled-to-perfection beef patty, toasted bun, crisp lettuce, juicy tomatoes, and red onions create a burst of flavors. Melted aged cheddar cheese and our signature sauce add creaminess and tanginess. Experience pure burger bliss with this timeless favorite.",
      imageUrl:
        "https://images.unsplash.com/photo-1550317138-10000687a72b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1220&q=80",
    },
    {
      title: "American Special Burger",
      description: "Experience the ultimate burger with our American Special. Two succulent beef patties, a toasted bun, red onions, beetroot-colored leaves, and melted cheddar cheese create a tantalizing flavor combination. Our restaurant sauce adds tangy and savory notes. Indulge in this mouthwatering feast for the senses.",
      imageUrl:
        "https://images.unsplash.com/photo-1549611016-3a70d82b5040?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=830&q=80",
    },
    {
      title: "Burger Sandwich",
      description: "Enjoy our delicious Burger Sandwich with juicy beef patty, pickles, lettuce, and mayo on freshly baked bread. Perfect for a satisfying and portable burger experience.",
      imageUrl:
        "https://images.unsplash.com/photo-1592415499556-74fcb9f18667?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=725&q=80",
    },
    {
      title: "Burger and French Fries Combo",
      description: "Indulge in our ultimate Burger and French Fries Combo. Juicy beef patty, toasted bun, and crispy fries create a classic and satisfying meal in one delicious package.",
      imageUrl:
        "https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80",
    },
  ];

export const backgroundImageUrl =
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixid=M3w0NTEzMDN8MHwxfHNlYXJjaHwxfHxidXJnZXJ8ZW58MHwwfHx8MTY4NDY5MzQ4OHww&ixlib=rb-4.0.3";
  
export const contactImageUrl =
    "https://images.unsplash.com/photo-1585730315658-faf260d0d335?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1925&q=80";

export const AboutusImageUrl =
    "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80";